import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Modal, Form, Button, Row, Col, Alert, Spinner } from 'react-bootstrap';
import UserDataService from '../../services/UserService';
import { UserFields } from '../../types/global';
import { User } from '../../types/global';
import { AxiosError } from 'axios';

interface AddUserModalProps {
    showModal: boolean;
    setShowModal: (show: boolean) => void;
    onUserAdded: (user: User) => void;
    userToEdit?: User;
    setUsersObject?: (Users: User[]) => void;
    setUserToEdit?:(User: User) => void;
}

const AddUserModal: React.FC<AddUserModalProps> = (props: any) => {

    const [formData, setFormData] = useState({
        firstname: '',
        lastname: '',
        photo: null as File | null,
        poste: '',
        telephone: '',
        fichecontact: null as File | null,
        email: '',
        lien1: '',
        lien2: '',
        lien3: '',
    });

    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (props?.userToEdit) {
            setFormData({
                firstname: props?.userToEdit?.firstname || '',
                lastname: props?.userToEdit?.lastname || '',
                photo: null as File | null,
                poste: props?.userToEdit?.poste || '',
                telephone: props?.userToEdit?.telephone || '',
                fichecontact: null as File | null,
                email: props?.userToEdit?.email || '',
                lien1: props?.userToEdit?.lien1 || '',
                lien2: props?.userToEdit?.lien2 || '',
                lien3: props?.userToEdit?.lien3 || '',
            });
        } else if (!props?.showModal) {
            console.log('hiiii')
            setFormData({
                firstname: '',
                lastname: '',
                photo: null,
                poste: '',
                telephone: '',
                fichecontact: null,
                email: '',
                lien1: '',
                lien2: '',
                lien3: '',
            });
        }
        console.log('userToEdit', props?.userToEdit);
        console.log('showModal', props?.showModal);
    }, [props?.userToEdit, props.showModal]);

    const isFormValid = useMemo(() => {
        const isEdit = !!props.userToEdit;
        const isEmptyForm = Object.values(formData).every(value => value === '' || value === null);
        if (isEdit) {
            return !isEmptyForm;
        }
        return (
            formData.firstname.trim() !== '' &&
            formData.lastname.trim() !== '' &&
            formData.photo !== null &&
            formData.poste.trim() !== '' &&
            formData.telephone.trim() !== '' &&
            formData.fichecontact !== null &&
            formData.email.trim() !== '' &&
            formData.lien1.trim() !== '' &&
            formData.lien2.trim() !== '' &&
            formData.lien3.trim() !== ''
        )
    }, [formData, props.userToEdit])

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, files } = e.target;
        if (files && files.length > 0) {
            setFormData(prevState => ({ ...prevState, [name]: files[0] }));
        } else {
            setFormData(prevState => ({ ...prevState, [name]: value }));
        }
    };

    const handleSubmit = async () => {
        const submitData = new FormData();
        submitData.append(UserFields.firstname, formData.firstname);
        submitData.append(UserFields.lastname, formData.lastname);
        if (formData.photo) {
            submitData.append(UserFields.photo, formData.photo as File);
        }
        submitData.append(UserFields.poste, formData.poste);
        submitData.append(UserFields.telephone, formData.telephone);
        if (formData.fichecontact) {
            submitData.append(UserFields.fichecontact, formData.fichecontact);
        }
        submitData.append(UserFields.email, formData.email);
        submitData.append(UserFields.lien1, formData.lien1);
        submitData.append(UserFields.lien2, formData.lien2);
        submitData.append(UserFields.lien3, formData.lien3);
        submitData.append(UserFields.cardurl, 'initial url');

        const submitDataObject: Record<string, any> = {};
        submitData.forEach((value, key) => {
            submitDataObject[key] = value;
        });

        setLoading(true);

        try {
            let response;
            if (props?.userToEdit) {
                response = await UserDataService.updateUser(props?.userToEdit._id, submitData);
                console.log('User updated successfully:', response);
                const completeUser = response.data;
                props?.setUsersObject?.((prevUsers: User[]) => 
                    prevUsers.map(user => user._id === completeUser._id ? completeUser : user)
                );
            } else {
                response = await UserDataService.createUser(submitData);
                console.log('User saved successfully:', response);
            }
            console.log('user specific link', `http://localhost:3030/user/${response._id}`);
            navigator.clipboard.writeText(response.cardurl);
            if (response && !props?.userToEdit) {
                props.onUserAdded(response);
            }
            props?.setUserToEdit(undefined);
            props.setShowModal(false);
        } catch (error) {
            console.error('Failed to save the user.', error);
            if (error instanceof AxiosError && error.response?.data?.message) {
                setErrorMessage(error.response.data.message);
            } else {
                setErrorMessage('Failed to save the user. Please check the fields and try again.');
            }
        } finally {
            setLoading(false);
        }
    }

    const closeModalHandler = useCallback(() => {
        props.setShowModal(false);
        props?.setUserToEdit(undefined);
    }, []);

    return(
        <Modal show={props.showModal}>
            <Modal.Body>
                <Row>
                    <Col>
                        <Form.Group className="mb-3">
                            <Form.Label>Prénom</Form.Label>
                            <Form.Control
                                name="firstname"
                                value={formData.firstname}
                                type="text"
                                placeholder="Michel"
                                autoFocus
                                onChange={handleInputChange}
                            />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group className="mb-3">
                            <Form.Label>Nom</Form.Label>
                            <Form.Control
                                name="lastname"
                                value={formData.lastname}
                                type="text"
                                placeholder="DUPOND"
                                autoFocus
                                onChange={handleInputChange}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Form.Group className="mb-3">
                    <Form.Label>Photo</Form.Label>
                    <Form.Control
                        name="photo"
                        type="file"
                        autoFocus
                        onChange={handleInputChange}
                    />
                </Form.Group>
                <Form.Group className="mb-3">
                    <Row>
                        <Col>
                            <Form.Label>Poste</Form.Label>
                            <Form.Control
                                name='poste'
                                value={formData.poste}
                                type="text"
                                autoFocus
                                onChange={handleInputChange}
                            />
                        </Col>
                        <Col>
                            <Form.Label>Téléphone</Form.Label>
                            <Form.Control
                                name='telephone'
                                value={formData.telephone}
                                type="text"
                                autoFocus
                                onChange={handleInputChange}
                            />
                        </Col>
                    </Row>
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>Fiche contact</Form.Label>
                    <Form.Control
                        name='fichecontact'
                        type="file"
                        autoFocus
                        onChange={handleInputChange}
                    />
                </Form.Group>
                <Row>
                    <Col>
                        <Form.Group className="mb-3">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                name='email'
                                value={formData.email}
                                type="email"
                                placeholder='michel@gmail.com'
                                autoFocus
                                onChange={handleInputChange}
                            />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group className="mb-3">
                            <Form.Label>Lien calendly</Form.Label>
                            <Form.Control
                                name='lien1'
                                value={formData.lien1}
                                type="text"
                                autoFocus
                                onChange={handleInputChange}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Group className="mb-3">
                            <Form.Label>Lien site web</Form.Label>
                            <Form.Control
                                name='lien2'
                                value={formData.lien2}
                                type="text"
                                autoFocus
                                onChange={handleInputChange}
                            />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group className="mb-3">
                            <Form.Label>Lien linkedin</Form.Label>
                            <Form.Control
                                name='lien3'
                                value={formData.lien3}
                                type="text"
                                autoFocus
                                onChange={handleInputChange}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                {errorMessage && (
                    <Alert variant="danger" className="mt-3">
                        {errorMessage}
                    </Alert>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={closeModalHandler}>
                    Fermer
                </Button>
                <Button variant="primary" disabled={!isFormValid || loading} onClick={handleSubmit}>
                    {loading ? <Spinner animation="border" size="sm" /> : 'Enregistrer'}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default AddUserModal;